import { getDataModelList } from '../../../services/aws';
import { setSpeciesModelOptions } from '../../../store/slices/appSlice';
import store from '../../../store/store';
import { extractModelInformation } from '../helpers';

// Function to fetch model data and update the Redux store
export const getModelDataResponse = async () => {
  const response = await getDataModelList();
  if (response.success) {
    const result = extractModelInformation(response.data);
    store.dispatch(setSpeciesModelOptions(result));
  }
};
